<template>
  <div>
    <Loading v-if="loading" />

    <v-sheet
      v-else
      :color="keyItem % 2 == 0 ? 'white' : 'grey lighten-4'"
      class="item"
      v-for="({ img, title, text }, keyItem) in items"
      :key="keyItem"
    >
      <v-container class="py-10">
        <Title class="text-center" small>{{ title }}</Title>
        <div class="d-inline-block mt-4 item-caption">
          <img
            v-if="img"
            :src="files + img"
            :alt="title"
            :class="
              'd-block mb-3 item-img ' +
              (keyItem % 2 == 0 ? 'float-left mr-sm-4' : 'float-right ml-sm-4')
            "
          />
          <div class="text-body-2 font-weight-regular item-text" v-if="text">
            <div v-html="text"></div>
          </div>
        </div>
      </v-container>
    </v-sheet>

    <v-container class="py-10">
      <v-sheet elevation="1">
        <v-tabs v-model="tab" center-active show-arrows centered class="mt-8">
          <v-tab v-for="({ title }, keyItems) in mission_items" :key="keyItems">
            <div>{{ title }}</div>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" class="pa-4 pa-md-5 tabs-mission">
          <v-tab-item
            v-for="({ img, text }, tabItemsKeys) in mission_items"
            :key="tabItemsKeys"
            class="item"
          >
            <v-row>
              <v-col cols="12" sm="4" v-if="img">
                <img :src="files + img" class="d-block item-img" />
              </v-col>
              <v-col cols="12" :sm="!img ? 12 : 8">
                <div
                  class="text-body-2 font-weight-regular"
                  v-if="text"
                  v-html="text"
                ></div>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-sheet>
    </v-container>
  </div>
</template>

<script>
import Loading from "../../widgets/Loading.vue";
import Title from "../../widgets/Title.vue";

const _config = {
  mod: "about",
};

export default {
  data: () => ({
    loading: true,
    tab: null,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    mission_items() {
      return this.$rest("mission").list;
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
    this.$rest("mission")
      .get()
      .then(() => (this.loading = false));
  },
  components: {
    Loading,
    Title,
  },
};
</script>

<style lang="scss" scoped>
.item {
  .item-caption {
    .item-img {
      max-width: 300px;
      width: 100%;
      @media screen and (max-width: 600px) {
        max-width: 100%;
      }
    }
  }
}
</style>
